/** Sections d'analytique — visible: false = masquée dans la nav (route conservée). */
export const ANALYTICS_SECTIONS = [
  { id: 'vue-ensemble', labelKey: 'nav_analytics_overview',  label: "Vue d'ensemble",      title: 'Analytiques', visible: true },
  { id: 'finance',      labelKey: 'nav_analytics_finance',   label: 'Finance',             title: 'Analytiques · Finance', visible: false },
  { id: 'commandes',    labelKey: 'nav_analytics_orders',    label: 'Commandes',           title: 'Analytiques · Commandes', visible: false },
  { id: 'clients',      labelKey: 'nav_analytics_clients',   label: 'Clients',             title: 'Analytiques · Clients', visible: false },
  { id: 'produits',     labelKey: 'nav_analytics_products',  label: 'Produits & catalogue', title: 'Analytiques · Produits', visible: false },
  { id: 'canaux',       labelKey: 'nav_analytics_channels',  label: 'Canaux de vente',     title: 'Analytiques · Canaux', visible: false },
];

export const visibleAnalyticsSections = () =>
  ANALYTICS_SECTIONS.filter((s) => s.visible !== false);
